module.exports = "/_next/static/images/0d27c7eee20ed29eb7fe8861776059da-clips@mobile480.jpg";